(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("DataModel", [], factory);
	else if(typeof exports === 'object')
		exports["DataModel"] = factory();
	else
		root["DataModel"] = factory();
})(window, function() {
return 